<template>
  <div class="detail" v-if="detail">
    <div class="item">
      <div class="title">ABOUT ME</div>
      <div class="desc">{{ detail.aboutMe }}</div>
    </div>
    <div class="item">
      <div class="title">ABOUT THIS SERVICE</div>
      <div class="desc">{{ serviceDetail.aboutYourService }}</div>
    </div>
    <div class="item">
      <div class="title">LOCATION</div>
      <div class="desc" v-if="detailLocation">
        {{ detailLocation.location.address.detail }}
      </div>
      <div class="desc" v-else>Travel to your own location (Zone 1 only)</div>
      <div v-show="true" class="map">
        <div v-if="detailLocation">
          <google-map v-model="detailLocation.location"></google-map>
        </div>
        <span v-else>Set your region at service area menu.</span>
      </div>
    </div>
    <div class="item">
      <div class="title">WHAT YOU WILL GET</div>
      <div class="desc" v-text="serviceDetail.whatYouOffer"></div>
    </div>
    <div class="item">
      <div class="title">DELIVERY OPTION</div>
      <div class="desc">
        Deliver the photos in 2 weeks from the shooting day with online link
      </div>
    </div>
    <div class="refund-box">
      <div class="item">
        <div class="title">REFUND</div>
        <div class="desc">
          Cancellation made 15 days prior to the scheduled shooting date - 100%
          refund within 7 business days and no payment will be made to the
          photographer
          <br />
          <br />Cancellation made 10 days prior to the scheduled shooting date -
          70% of the total amount will be refunded within 7 business days and
          40% of non-refunded amount will be paid to the photographer
          <br />
          <br />Cancellation made 5 days prior to the scheduled shooting date -
          50% of the total amount will be refunded within 7 business days and
          50% of non-refunded amount will be paid to the photographer
          <br />
          <br />Cancellation made 2 days prior to the scheduled shooting date –
          No refund for the customer and 60% of non-refunded amount will be paid
          to the photographer
        </div>
      </div>
      <div class="item">
        <div class="title">WEATHER</div>
        <div class="desc">
          No photograph session is allowed - If rescheduling or replacement with
          indoor shooting session are not possible because of the severe
          weather, 60% of your payment will be refunded (service fee is
          excluded) and 50% of non-refunded amount will be paid to the
          photographer
          <br />
          <br />Light Rain / Light Snow - Shooting with umbrella / Rescheduling
          or Replacement with indoor shooting session are available
          <br />
          <br />Heavy Snow / Heavy Rain / Heatwave - Rescheduling the date with
          the photographer is a given priority and replacement with indoor
          shooting session is also available
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getProfile } from '../../api/profile'
import { getServiceArea } from '../../api/serviceArea'
import GoogleMap from '../common/GoogleMap'

export default {
  name: 'detail',
  components: { GoogleMap },
  data() {
    return {
      detail: {},
      detailLocation: ''
    }
  },
  mounted() {
    if (this.serviceDetail) {
      getProfile(this.serviceDetail.uid).then(res => {
        this.detail = res
      })

      getServiceArea(this.serviceDetail.uid).then(result => {
        this.detailLocation = result
      })
    }
  },
  // methods: {
  // checkProperty(obj, property) {
  // console.log('Object.entries(obj).length:', Object.entries(obj))
  // console.log(obj, property)
  // return Object.entries(obj).filter(v => {
  //     if (typeof v === 'object') {
  //         console.log('property:', v)
  //         return this.checkProperty(v, property)
  //     } else {
  //         return v.hasOwnProperty(property)
  //     }
  // })
  //   }
  // },
  computed: {
    ...mapGetters(['serviceDetail', 'modalComponentPropData'])
  }
}
</script>

<style lang="scss" scoped>
.detail {
  width: 95%;
  font-size: 16px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1px;
  padding: 0 0 50px 0;

  .refund-box {
    width: 90%;
    padding: 20px;
    background-color: #f5f5f5;

    .item {
      margin-bottom: 20px;

      &.line {
        border-bottom: 1px solid #dbdbdb;
        padding: 0 0 20px 0;
      }

      .title {
        font-family: Poppins;
        font-size: 17px;
        letter-spacing: 1px;
        font-weight: 600;
        margin: 0 0 4px 0;
      }

      .desc {
        font-family: Poppins;
        font-size: 16px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 1px;
      }
    }
  }

  .item {
    margin-bottom: 20px;

    &.line {
      border-bottom: 1px solid #dbdbdb;
      padding: 0 0 20px 0;
    }

    .title {
      font-family: Poppins;
      font-size: 17px;
      letter-spacing: 1px;
      font-weight: 600;
      margin: 0 0 4px 0;
    }

    .desc {
      font-family: Poppins;
      font-size: 16px;
      font-weight: 300;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: 1px;
    }

    .google-map {
      margin: 12px 0 0 0;
      width: 100%;
      height: 400px;
      /*border: 1px solid red;*/
    }
  }
}
</style>
